import React from 'react';
import { Badge } from 'react-bootstrap';
import { SummaryBlock } from '../common/SummaryBlock';
import { Spacer } from '../common/Spacer';
import { CheckoutSiteInfo } from '../checkout/CheckoutSiteInfo';

export const LastCheckinSummary = () => {

    return (
        <>
            <SummaryBlock display className="text-center">
                <Badge variant='secondary' pill className="py-2 px-3">
                    <strong className="pr-2">✕</strong>You are not currently checked in
                </Badge>
            </SummaryBlock>
            <Spacer height="1em"/>
            <SummaryBlock display className="body-text body-text-pl mb-1">
                Summary of previous site visit
            </SummaryBlock>
            <CheckoutSiteInfo />
        </>
    );
}
